import React, { ReactNode } from 'react';
import ico_earth from '../../../public/images/icons/ico_earth.svg';
import ico_calendar_planning from '../../../public/images/icons/ico_calendar_planning.svg';
import ico_hiking from '../../../public/images/icons/ico_hiking.svg';
import ico_flag from '../../../public/images/icons/ico_flag.svg';
import ico_camera from '../../../public/images/icons/ico_camera.svg';
import ico_camera_white from '../../../public/images/icons/ico_camera_white.svg';
import ico_bag from '../../../public/images/icons/ico_bag.svg';
import ico_bag_white from '../../../public/images/icons/ico_bag_white.svg';
import ico_study from '../../../public/images/icons/ico_study.svg';
import ico_study_white from '../../../public/images/icons/ico_study_white.svg';
import ico_other from '../../../public/images/icons/ico_other.svg';
import ico_other_white from '../../../public/images/icons/ico_other_white.svg';
import { RiskFactorComponentView } from './RiskFactorComponentView';
import { WprButton } from '../../wpr-framework/component/controls/WprButton';
import { WprContainer } from '../../wpr-framework/component/controls/WprContainer';
import { WprInput } from '../../wpr-framework/component/controls/WprInput';
import { WprRadio } from '../../wpr-framework/component/controls/WprRadio';
import { WprBaseRouteViewComponent } from '../../wpr-framework/view/component/WprBaseRouteViewComponent';
import { withRouter } from 'react-router';
import { WprSelect } from '../../wpr-framework/component/controls/WprSelect';
import { WprDiv } from '../../wpr-framework/component/controls/WprDiv';
import { WprViewError } from '../../wpr-framework/component/controls/WprViewError';
import { HeaderComponent } from '../common/header/HeaderComponent';
import { FooterComponent } from '../common/footer/FooterComponent';
import { WprSpan } from '../../wpr-framework/component/controls/WprSpan';

/**
 * リスクファクター
 */
class RiskFactorComponent extends WprBaseRouteViewComponent {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: any) {
		super(new RiskFactorComponentView(), props);
	}

	public handleClick = (e: React.MouseEvent, props) => {
		e.nativeEvent.stopImmediatePropagation();
		const targetId = e.currentTarget.id;
		$('#' + targetId.replace('-lbl', '')).off('click');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
     * 描画
     */
	public onRender(): ReactNode {
		return (
			<>
				<HeaderComponent />
				<div className="step">
					<div className="wrap">
						<div className="stepper">
							<ul>
								<li className="now">
									<span>1</span>
									<p className="conf" id="step1">
										旅行内容の確認
									</p>
								</li>
								<li><span>2</span></li>
								<li><span>3</span></li>
								<li><span>4</span></li>
							</ul>
						</div>
					</div>
				</div>
				<div className="page-risk-factor">
					<WprContainer mode='noticeView.表示' view={this.view} >
						<div className="announcement">
							<WprSpan name='notice' view={this.view}></WprSpan>
						</div>
					</WprContainer>
					<div className="main">
						<div className="top">
							<h2>
									旅行について教えてください
							</h2>
							<p className="c-quest-s">
									をクリックすると説明が表示されます。
							</p>
						</div>
						<div className="content">
							<WprContainer mode='OTA' view={this.view} >
								<dl className="wrap-dest">
									<dt>
										<img src={ico_earth} />
										<span>主な旅行先はどちらですか？</span>
										<WprButton className="c-quest-b" data-layer-show="q-1" name="q-1" view={this.view}></WprButton>
									</dt>
									<dd>
										<div className="c-select">
											<WprSelect name="dest" view={this.view} vm="nation" placeholder='旅行先を選ぶ' ></WprSelect>
										</div>
										<div className="c-errmsg" data-error="dest">
											<WprViewError name="dest" view={this.view} />
										</div>
									</dd>
								</dl>
							</WprContainer>
							<dl className="wrap-period">
								<dt>
									<img src={ico_calendar_planning} />
									<span>旅行期間（保険期間）はいつですか？</span>
									<WprButton className="c-quest-b" data-layer-show="q-2" name="q-2" view={this.view}></WprButton>
								</dt>
								<dd>
									<div className="c-date">
										<WprInput name="periodFrom" className="hasDatepicker"
											type="text" view={this.view} id="id-period-from"/>
									</div>
									<div className="c-date">
										<WprInput name="periodTo" className="hasDatepicker"
											type="text" view={this.view} id="id-period-to"/>
									</div>
									<p className="c-errmsg" data-error="period_from"></p>
									<p className="c-errmsg" data-error="period_to"></p>
								</dd>
							</dl>
							<dl className="wrap-person">
								<dt>
									<img src={ico_hiking} />
									<span>旅行される方は何名ですか？</span>
									<WprButton className="c-quest-b" data-layer-show="q-3" name="q-3" view={this.view}></WprButton>
								</dt>
								<dd>
									<div className="c-select">
										<WprSelect name="person" view={this.view} vm="person" placeholder='人数を選ぶ'></WprSelect>
									</div>
									<span className="mei">名</span>
									<div className="c-errmsg" data-error="person">
										<WprViewError name="person" view={this.view} />
									</div>
								</dd>
							</dl>
							<dl className="wrap-purpose">
								<dt>
									<img src={ico_flag} />
									<span>どんな目的の旅行ですか？</span>
								</dt>
								<dd className="c-radio">
									<WprRadio name="purpose" className="pur" id="id-purpose-sight" value="1" view={this.view}/>
									<label htmlFor="id-purpose-sight" onClick={e => this.handleClick(e, this.props)} id="id-purpose-sight-lbl">
										<div>
											<WprContainer mode='1' invisible view={this.view}><img src={ico_camera} data-icon="sight"/></WprContainer>
											<WprContainer mode='1' view={this.view}><img src={ico_camera_white} data-icon="sight"/></WprContainer>
											<span>観光</span>
										</div>
									</label>
									<WprRadio name="purpose" className="pur" id="id-purpose-commercial" value="3" view={this.view} />
									<label htmlFor="id-purpose-commercial" onClick={e => this.handleClick(e, this.props)} id="id-purpose-commercial-lbl">
										<div>
											<WprContainer mode='3' invisible view={this.view}><img src={ico_bag} data-icon="commercial"/></WprContainer>
											<WprContainer mode='3' view={this.view}><img src={ico_bag_white} data-icon="commercial"/></WprContainer>
											<span>商用</span>
										</div>
									</label>
									<WprContainer mode='OTA' view={this.view} >
										<WprRadio name="purpose" className="pur" id="id-purpose-study" value="4" view={this.view} />
										<label htmlFor="id-purpose-study" onClick={e => this.handleClick(e, this.props)} id="id-purpose-study-lbl">
											<div>
												<WprContainer mode='4' invisible view={this.view}><img src={ico_study} data-icon="study"/></WprContainer>
												<WprContainer mode='4' view={this.view}><img src={ico_study_white} data-icon="study"/></WprContainer>
												<span>留学</span>
											</div>
										</label>
									</WprContainer>
									<WprRadio name="purpose" className="pur" id="id-purpose-other" value="9" view={this.view} />
									<label htmlFor="id-purpose-other" onClick={e => this.handleClick(e, this.props)} id="id-purpose-other-lbl">
										<div>
											<WprContainer mode='9' invisible view={this.view}><img src={ico_other} data-icon="other"/></WprContainer>
											<WprContainer mode='9' view={this.view}><img src={ico_other_white} data-icon="other"/></WprContainer>
											<span>その他</span>
										</div>
									</label>
								</dd>
							</dl>
						</div>
					</div>
					<WprContainer mode='OTA' view={this.view} >
						<div className="possible">
							<dl>
								<dt>下記条件を満たす方がお申込みいただけます</dt>
							</dl>
							<dl>
								<dt>ご契約者様（申込みをされる方）</dt>
								<dd>
									<ul>
										<li>・日本にお住まいの方</li>
										<li>・日本国内から申込まれる方</li>
										{/* WRQ-3106_旅行保険 引受年齢満18歳対応 START */}
										<li>・申し込み時点で満18歳以上の方</li>
										{/* <li>・申し込み時点で満20歳以上の方</li> */}
										{/* WRQ-3106_旅行保険 引受年齢満18歳対応 END */}
										<li>・キャッシュレス・クレジットカード等でお支払いできる方</li>
										<li>（銀行振込・コンビニ払いは承れません。）</li>
									</ul>
								</dd>
							</dl>
							<dl>
								<dt>ご旅行者（被保険者）</dt>
								<dd>
									<ul>
										<li>・日本にお住まいの方</li>
										{/* WRQ-3804_【旅行保険】ホワイトラベル 海外旅行保険プランの引受年齢チェック変更 START */}
										<li>・出発日時点で満79歳以下の方（但し、疾病死亡補償がある場合満69歳以下の方）</li>
										{/* <li>・出発日時点で69歳以下の方</li> */}
										{/* WRQ-3804_【旅行保険】ホワイトラベル 海外旅行保険プランの引受年齢チェック変更 END */}
										<li>・旅行中に危険な運動をされない方</li>
										<li>・旅行先にキューバが含まれていない方</li>
									</ul>
								</dd>
								<dd>
									<ul>
										<li>※詳細は重要事項説明書をご確認ください。</li>
										{/* WRQ-2990_旅行保険　直扱販売のための対応 START */}
										<li>※なお、当社の引受基準により保険のお引き受けができない場合がございますので、あらかじめご了承ください。</li>
										{/* WRQ-2990_旅行保険　直扱販売のための対応 END */}
									</ul>
								</dd>
							</dl>
						</div>
					</WprContainer>
					<WprContainer mode='DTP' view={this.view} >
						<div className="possible">
							<dl>
								<dt>下記条件を満たす方がお申込みいただけます</dt>
							</dl>
							<dl>
								<dt>ご契約者様（申込みをされる方）</dt>
								<dd>
									<ul>
										<li>・日本にお住まいの方</li>
										<li>・日本国内から申込まれる方</li>
										{/* WRQ-3106_旅行保険 引受年齢満18歳対応 START */}
										<li>・申し込み時点で満18歳以上の方</li>
										{/* <li>・申し込み時点で満20歳以上の方</li> */}
										{/* WRQ-3106_旅行保険 引受年齢満18歳対応 END */}
										<li>・キャッシュレス・クレジットカード等でお支払いできる方</li>
										<li>（銀行振込・コンビニ払いは承れません。）</li>
									</ul>
								</dd>
							</dl>
							<dl>
								<dt>ご旅行者（被保険者）</dt>
								<dd>
									<ul>
										<li>・日本にお住まいの方</li>
										{/* WRQ-3804_【旅行保険】ホワイトラベル 海外旅行保険プランの引受年齢チェック変更 START */}
										<li>・出発日時点で満80歳以下の方</li>
										{/* WRQ-3804_【旅行保険】ホワイトラベル 海外旅行保険プランの引受年齢チェック変更 END */}
										<li>・旅行中に危険な運動をされない方</li>
									</ul>
								</dd>
								<dd>
									<ul>
										<li>※詳細は重要事項説明書をご確認ください。</li>
										{/* WRQ-2990_旅行保険　直扱販売のための対応 START */}
										<li>※なお、当社の引受基準により保険のお引き受けができない場合がございますので、あらかじめご了承ください。</li>
										{/* WRQ-2990_旅行保険　直扱販売のための対応 END */}
									</ul>
								</dd>
							</dl>
						</div>
					</WprContainer>
					<div className="plan">
						<WprDiv className="pittari" name="pittari" view={this.view}>あなたにピッタリの</WprDiv>
						<WprButton className="c-button" name="next" view={this.view}>
							<span>旅行保険プランを確認する</span>
						</WprButton>
					</div>
				</div>

				<WprContainer mode="q-1" view={this.view}>
					<div className="c-layer" data-layer="q-1">
						<div className="box">
							<h1>主な旅行先はどこですか？</h1>
							<p>旅行先が複数ある場合は最も滞在時間が長いひとつを選択してください。</p>
							<WprButton className="button" data-layer-hide="q-1" name="close" view={this.view}>閉じる</WprButton>
						</div>
					</div>
				</WprContainer>
				<WprContainer mode="q-2" view={this.view}>
					<div className="c-layer" data-layer="q-2">
						<div className="box">
							<h1>旅行期間（保険期間）はいつですか？</h1>
							<p>旅行期間はご自宅を出発する日からご自宅に戻られる日を選択してください。<br />
								<br />※ご自宅を出発する日の60日前からお申込みいただけます。<br />※保険期間は最長30日までとなります。</p>
							<WprButton className="button" data-layer-hide="q-2" name="close" view={this.view}>閉じる</WprButton>
						</div>
					</div>
				</WprContainer>
				<WprContainer mode="q-2-1" view={this.view}>
					<div className="c-layer" data-layer="q-2">
						<div className="box">
							<h1>旅行期間（保険期間）はいつですか？</h1>
							<p>旅行期間はご自宅を出発する日（日本時間）からご自宅に戻られる日（日本時間）を選択してください。<br />
								<br />※ご自宅を出発する日の60日前からお申込みいただけます。<br />※保険期間は最長30日までとなります。</p>
							<WprButton className="button" data-layer-hide="q-2" name="close" view={this.view}>閉じる</WprButton>
						</div>
					</div>
				</WprContainer>
				<WprContainer mode="q-3" view={this.view}>
					<div className="c-layer" data-layer="q-3">
						<div className="box">
							<h1>旅行される方は何名ですか？</h1>
							<p>旅行される方（被保険者）の人数を選択してください。<br />旅行者全ての方のお名前と生年月日の登録をのちほど入力いただきます。
								<br />※保険申込人ご本人も旅行者の場合は、含んだ人数を選択してください。</p>
							<WprButton className="button" data-layer-hide="q-3" name="close" view={this.view}>閉じる</WprButton>
						</div>
					</div>
				</WprContainer>
				<FooterComponent />
			</>
		);
	}
}

export default withRouter(RiskFactorComponent);